// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-10-29 15:40:15 +0100 (Wed, 29 Oct 2025) $
//  Author    : Dirk Rothe, Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 157607 $
//  Purpose   : wiki parts
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {loadLazy as ll, Part} from 'uix/parts'
import {XMenu} from 'uix/components'

// ---Local imports
import {WikiPane} from '../render'
import {WikiAlternatives} from '../components'

// ---Globals
export const SimpleWikiList = ll(() => import(/* webpackChunkName: 'wiki' */ './simple'))
//~ export const WikiEditor = loadLazy(() => import(/* webpackChunkName: 'wiki' */ './editor'))
export {WikiEditor} from './editor'
export const WikiHistory = ll(() => import(/* webpackChunkName: 'wiki' */ './history'))

export class Wikiblock extends Part {
  _render() {
    let {request, wiki, go, partcfg} = this.props
    let {showMenu = false, showAlternatives = false} = partcfg
    if (!wiki) {
      return null
    }

    let editParams = wiki.otid ? {id: wiki.otid} : {query: {identifier: wiki.identifier}}
    let editWiki = () => go({classname: 'xwiki', tabname: 'edit', ...editParams})

    let menu = (
      <XMenu floated="right" padded>
        <XMenu.Item icon="edit" onClick={editWiki} />
      </XMenu>
    )
    let style = showAlternatives ? {flex: 1, overflow: 'auto'} : {}
    return (
      <>
        <div className="wikiblock" style={style}>
          {showMenu && menu}
          {wiki.missing ? null : (
            <WikiPane rendered={wiki.rendered} identifier={wiki.identifier} otid={wiki.otid} />
          )}
        </div>
        {showAlternatives && <WikiAlternatives />}
      </>
    )
  }
}

export const WikiSearch = ll(() => import(/* webpackChunkName: 'wiki' */ './search'))
